/** Button Element Types
    @readonly
    @enum {string}
*/
export var BUTTONTYPES;
(function (BUTTONTYPES) {
    BUTTONTYPES["BUTTON"] = "button";
    BUTTONTYPES["RESET"] = "reset";
    BUTTONTYPES["SUBMIT"] = "submit";
})(BUTTONTYPES || (BUTTONTYPES = {}));
;
